module.exports = __webpack_public_path__ + "static/img/branch_1.1b3e806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/branch_1.jpg
// module id = iFy2
// module chunks = 0